import { EntityLinks, Goal, ID } from '@griply/types';

import {
  getArchivedGoalIds,
  getCompletedBranchGoalIds,
} from '../derived-goal-state';

export type FilterGoalsOptions = {
  links: EntityLinks;
  hideUnplanned?: boolean;
  hideCompleted?: boolean;
  hideArchived?: boolean;
};

export const filterGoals = (
  goals: Goal[],
  { links, hideUnplanned, hideCompleted, hideArchived }: FilterGoalsOptions,
): Goal[] => {
  if (!hideUnplanned && !hideCompleted && !hideArchived) {
    return goals;
  }

  const archivedIds = hideArchived
    ? getArchivedGoalIds(goals, { links })
    : new Set<ID>();
  const completedBranchIds = hideCompleted
    ? getCompletedBranchGoalIds(goals, { links })
    : new Set<ID>();
  return goals.filter((goal) => {
    if (hideUnplanned && (!goal.startDate || !goal.deadline)) {
      return false;
    }

    if (hideCompleted && completedBranchIds.has(goal.id)) {
      return false;
    }

    return !(hideArchived && archivedIds.has(goal.id));
  });
};
